import {
    CreateDesignServiceRequestDataPartial,
    CreateDesignServiceRequestType,
    CreateDesignServiceResponseType,
    DesignLiveAppointmentDate,
    DesignLiveAppointmentTime,
    GetAvailableAppointmentDatesRequestType,
    GetAvailableAppointmentTimesRequestType,
} from '../../types';
import { APIClient } from './APIClient';

export class VPMerchantClient extends APIClient {
    /** 
     Makes a POST request to the DesignRequest endpoint, creating a design
     service request. The associated swagger documentation can be found here:

     https://developer.cimpress.io/software-catalog/component/api/8025f206-6d80-58cc-a932-a0e6b32c77a3/openapi?env=production#/DesignRequest/post_v1_DesignRequest
     */
    public createDesignServicesRequest(
        payload: CreateDesignServiceRequestType
    ): Promise<CreateDesignServiceResponseType> {
        return this.fetchJSON('/DesignRequest', {
            method: 'POST',
            body: JSON.stringify(payload),
        });
    }

    /** 
     Makes a PUT request to the DesignRequest endpoint, updating the data field on 
     a design service request. The associated swagger documentation can be found here:

     https://developer.cimpress.io/software-catalog/component/api/8025f206-6d80-58cc-a932-a0e6b32c77a3/openapi?env=production#/DesignRequest/put_v1_DesignRequest__requestAltId__data
     */
    public updateDesignServicesRequestData(
        payload: CreateDesignServiceRequestDataPartial,
        requestAltId: string
    ): Promise<CreateDesignServiceResponseType> {
        return this.fetchJSON(`/DesignRequest/${requestAltId}/data`, {
            method: 'PUT',
            body: JSON.stringify(payload),
        });
    }

    /**
     Makes a GET request to the Appointment endpoint to fetch the available dates for DesignLive session.
     The associated swagger documentation can be found here:

     https://developer.cimpress.io/software-catalog/component/api/8025f206-6d80-58cc-a932-a0e6b32c77a3/openapi?env=production#/Appointment/get_v1_Appointment_availability_dates
     */
    public getAvailableAppointmentDates(
        queryParams: GetAvailableAppointmentDatesRequestType
    ): Promise<DesignLiveAppointmentDate[]> {
        return this.fetchJSON(
            `/Appointment/availability/dates?locale=${queryParams.locale}&timezone=${queryParams.timezone}`,
            {
                method: 'GET',
            }
        );
    }

    /**
     Makes a GET request to the Appointment endpoint to fetch the available times for a DesignLive session.
     The associated swagger documentation can be found here:

     https://developer.cimpress.io/software-catalog/component/api/8025f206-6d80-58cc-a932-a0e6b32c77a3/openapi?env=production#/Appointment/get_v1_Appointment_availability_times
     */
    public getAvailableAppointmentTimes(
        queryParams: GetAvailableAppointmentTimesRequestType
    ): Promise<DesignLiveAppointmentTime[]> {
        return this.fetchJSON(
            `/Appointment/availability/times?date=${queryParams.date}&locale=${queryParams.locale}&timezone=${queryParams.timezone}`,
            {
                method: 'GET',
            }
        );
    }
}
